/**
 * @link (docs) https://vue-i18n.intlify.dev/
 */
import { createI18n } from "vue-i18n";

import { en, nl, zh } from "@/lang/messages";

export const i18nInstance = createI18n({
  legacy: false, // you must set `false`, to use Composition API (see: https://vue-i18n.intlify.dev/guide/advanced/composition.html)
  // the locale is which language/locale the app defaults to
  locale: "en",
  // the fallbackLocale determines what language a message shown is in
  // when there is no specified message in the selected language already
  fallbackLocale: "en",
  messages: {
    en,
    nl,
    zh,
  },
  //Custom pluralizationRules
  pluralizationRules: {
    "pages.customization.pluralization": function (choice) {
      if (choice <= 1) {
        return 0;
      }

      if (choice > 1) {
        return 1;
      }
    },
  },
});

/**
 * this exposes a global i18n instance to the whole application so that it
 * can be used outside of components
 */
export const i18n = i18nInstance.global;
